/**
 * Acessibilidade — "Reduzir movimento" (ACC-4, doc 07 §12). Fonte da verdade: `?reducemotion=1/0`
 * (teste), depois localStorage `rabbit.reducemotion`, depois a media query do SO
 * `prefers-reduced-motion`. Todo efeito de MOVIMENTO (shake, flash, inversão) consulta este helper:
 * ligado → shake/flash NÃO acontecem e inversão de cor vira dessaturação.
 */
import type Phaser from 'phaser';

export function reducedMotion(search: string = typeof location !== 'undefined' ? location.search : ''): boolean {
  try {
    const q = new URLSearchParams(search).get('reducemotion');
    if (q === '1') return true;
    if (q === '0') return false;
    if (typeof localStorage !== 'undefined' && localStorage.getItem('rabbit.reducemotion') === '1') return true;
    return typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}

/** dá um tremor de câmera — NO-OP quando "reduzir movimento" está ligado. Retorna se tremeu. */
export function shakeCamera(scene: Phaser.Scene, duration = 120, intensity = 0.004): boolean {
  if (reducedMotion()) return false;
  scene.cameras.main.shake(duration, intensity);
  return true;
}

/** para efeitos de cor: com "reduzir movimento", inversão vira dessaturação (ACC-4). */
export function inversionMode(): 'invert' | 'desaturate' {
  return reducedMotion() ? 'desaturate' : 'invert';
}
